import styled from 'styled-components';

import { mediaConfined } from '@xingternal/layout-tokens';
import { Menu, MenuHeadline, SingleSelect } from '@xingternal/menu';
import { Tag } from '@xingternal/tag';
import {
  scale040,
  scale080,
  xdlColorLink,
  xdlColorText,
} from '@xingternal/tokens';

export const StyledTag = styled(Tag)`
  padding: ${scale040} ${scale080};
  height: 44px;
`;

export const StyledMenu = styled(Menu)`
  @media ${mediaConfined} {
    max-width: 252px;
  }
`;

export const StyledMenuHeadline = styled(MenuHeadline)`
  color: ${xdlColorText};
`;

export const StyledMoreOptions = styled(SingleSelect)`
  color: ${xdlColorLink};
  text-decoration: underline;

  &:hover {
    text-decoration: underline;
  }
`;
